export { applyEntitySchema, rememberPayload } from './apply'
export { carrySettingUnknown } from './carry'
export { cloneFcdcEntity } from './clone'
export { editPreservingUnknown } from './edit'
export { editsFromView, sourceJson, wireEntity, wireValue } from './entity-edits'
export { unwrapLegacyExtras } from './legacy-extras'
export { jsonFromStorage, normalizeEntityForStorage } from './storage'
export { reportDrift, resetDriftLog } from './drift'
export { dirtyPatch } from './form-patch'
export { assertUnknownPathsUntouched, FcdcGuardError } from './guard'
export { arrayItemPatch, mergePatch } from './merge-patch'
export { attachRaw, getRaw, hasRaw } from './raw'
export {
  enumWithFallback,
  objectSchema,
  openEnum,
  openUnion,
  optionalTolerant,
  parseEntity,
  requiredTolerant,
  tolerant,
  tolerantArray,
  tolerantEnum,
  unrecognized,
} from './schema'
export type { Unrecognized } from './schema'
export { attachUnknown, getUnknown, isDegraded } from './unknown'
export type { UnknownPath } from './unknown'

import { assertUnknownPathsUntouched } from './guard'
import { mergePatch } from './merge-patch'
import { getRaw, hasRaw } from './raw'
import { getUnknown } from './unknown'

/** Client-side full body: `$raw` with only the dirty edits applied. */
export function toWire(entity: object, edits: unknown): unknown {
  const raw = getRaw(entity)
  const body = mergePatch(raw, edits)
  assertUnknownPathsUntouched(raw, body, getUnknown(entity))
  return body
}

/**
 * PUT body for CacheService.
 * A patch argument always wins and is merged onto `$raw`.
 * Unmigrated entities still serialize with `toJSON()`.
 */
export function saveBody(entity: object, edits?: unknown): unknown {
  if (edits !== undefined) {
    return toWire(entity, edits)
  }

  const toJSON = (entity as { toJSON?: () => unknown }).toJSON
  if (typeof toJSON === 'function') {
    return toJSON.call(entity)
  }

  if (hasRaw(entity)) {
    return toWire(entity, {})
  }

  return entity
}
